import styles from '../../../../styles/modules/utils.module.scss';
import type { Term } from '../../types';

export interface TermBodyProps {
  body: Term;
}

function TermBody({ body }: TermBodyProps) {
  return (
    <div
      className={`${styles.mtSmall} ${styles.textHtml} ${styles.textSmall}`}
      // biome-ignore lint/security/noDangerouslySetInnerHtml: HTML content from API
      dangerouslySetInnerHTML={{ __html: body.term }}
    />
  );
}

export default TermBody;
